import * as React from  'react'
import {IFooterComponentProps} from "./IFooterComponentProps";
import {IFooterComponentState} from "./IFooterComponentState";
import { Link, Redirect } from 'react-router-dom'
import CreateGifModalComponent from "../createGifModalComponent/CreateGifModalComponent";
import { Header, Icon, Image, Segment, Sidebar } from 'semantic-ui-react'
import { slide as Menu } from 'react-burger-menu'
import 'src/assets/css/main.css';
import 'src/assets/css/reset.css';
import 'src/assets/css/fonts.css';
import facebook  from 'src/assets/images/Facebook.png'
import instagram  from 'src/assets/images/Instagram.png'
import twitter  from 'src/assets/images/Twitter.png'
import pen  from 'src/assets/images/pen.png'
import logo  from 'src/assets/images/logo.png'
import upload  from 'src/assets/images/Upload.png'
import menu  from 'src/assets/images/menu.png'
import * as actions from "../../actions/modalActions";
import {connect} from "react-redux";
import LoginModal from "../loginModal/LoginModal";


 class FooterComponent extends React.Component<IFooterComponentProps , IFooterComponentState> {

    constructor(props: IFooterComponentProps) {
        super(props)

        // Default state
        this.state = {
                redirectToUpload: false,
                redirectToHome: false,
                SidebarVisiblity: true ,
                menuOpen : false
        }
    }
    setRedirectToUpload = () => {
        this.setState({
            redirectToUpload: true
        })
    }
    setRedirectToHome = () => {
        this.setState({
            redirectToHome: true
        })
    }
    handleShowClick = () => {
            this.setState({ SidebarVisiblity: true })
            console.log(this.state.SidebarVisiblity)
        }
    handleSidebarHide = () => this.setState({ SidebarVisiblity: false })
    renderRedirect = () => {
        if (this.state.redirectToUpload) {
            return <Redirect push  to='/uploadgif' />
        }
        else if (this.state.redirectToHome) {
            return <Redirect push  to='/' />
        }
    }
    handleStateChange (state) {
         this.setState({menuOpen: state.isOpen})
     }
    closeMenu () {
         this.setState({menuOpen: false})
     }
    toggleMenu () {
         this.setState(state => ({menuOpen: !state.menuOpen}))
     }
    public render() {
        const { SidebarVisiblity } = this.state
        return (
            <div style={{marginTop : '120px'}}>
                {this.renderRedirect()}
                <footer className="_footer">
                <div className="container">
                    <div className="row">
                        <div className="col txt-left">Tous droits réservés © JWT</div>
                        <div className="col">
                            <div className="row">
                                <div className="col">
                                    <a href="#">
                                        <img className="facebook" src={facebook}/>
                                    </a>
                                </div>
                                <div className="col">
                                    <a href="#">
                                        <img className="instagram" src={instagram}/>
                                    </a>
                                </div>
                                <div className="col">
                                    <a href="#">
                                        <img className="twitter" src={twitter}/>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="col txt-right">
                            <a href="#">Conditions générales d'utilisation</a>
                        </div>
                    </div>
                </div>
            </footer>
                <footer className="_fixedFooter">
                    <div className="row">
                        <div className="_col logo" onClick={this.setRedirectToHome}><img style={{maxWidth: '80px'}} src={logo} alt="logo"/></div>
                        <div className="_col upload" onClick={this.setRedirectToUpload} data-href="link" >
                            <div className="_img">
                                <img src={upload} style={{maxWidth: '40px'}} alt="icone footer menu"/>
                            </div>
                            <span>Importer</span>
                        </div>
                        <CreateGifModalComponent />
                        {this.props.authenticated ?
                            <div

                                onClick={() =>{
                                    console.log('teest')

                                    this.props.openSideBar(!this.props.openSide)
                                }
                                }

                                className="_col menu" id="menuOpened" data-href="link">
                                <div className="_img" style={{top: "40%"}}>
                                    <img src={menu} style={{maxWidth: '40px'}} alt="icone footer menu"/>
                                </div>
                                <span>Menu</span>
                            </div> :
                            <div
                                className="_col menu" id="menuOpened" data-href="link">
                                <div className="_img" style={{top: "20%"}}>
                                    <LoginModal/>
{/*
                                    <img src={menu} style={{maxWidth: '40px'}} alt="icone footer menu"/>
*/}
                                </div>
                                <span style={{marginTop : '10px'}}>Login</span>
                            </div>
                            }

                    </div>

                </footer>
            </div>
        );

    }
}

const mapDispatchToProps = (dispatch: any, ownProps: IFooterComponentProps) => {
    return {
        openSideBar: (open) => dispatch(actions.sideBar(open)),
    }
}
function mapsStateToProps(state) {
    return {
        errorMessage: state.auth.errorMessage,
        openSide : state.toast.openSide,
        authenticated : state.auth.authenticated


    };
}
export default connect(mapsStateToProps, mapDispatchToProps)(FooterComponent)





// WEBPACK FOOTER //
// ./src/components/footerComponent/FooterComponent.tsx